<template>
    <div>
        <!-- <div>
<Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />
        </div> -->
        

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>Offered Subject List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                    <v-autocomplete @change="getOffSub()" rounded outlined dense v-model="list_selected_ay"
                        :items="list_ay" item-text="ay" label="Academic year" persistent-hint return-object
                        single-line></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" md="4" sm="4">
                    <v-btn class="button" @click="getOffSub()">Fetch Subject</v-btn>
                </v-col> -->
            </v-row>

            <v-row justify="center" v-if="list_selected_ay">
                <v-col cols="12" md="2" sm="2"> </v-col>
                <v-col cols="12" md="4" sm="4">
                    <v-text-field class="pt-2" v-model="search" append-icon="search" label="Search" single-line
                        hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                    <v-btn class="button" @click="offer">Offer Subject</v-btn>
                </v-col>
            </v-row>
            <v-dialog v-model="dialog" max-width="900px">
                <v-card>
                    <v-toolbar class="ma-2 toolbar" flat dense>
                        <v-toolbar-title>Offered Subject</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row class="p-0 m-0">
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="subject" :items="subjectlist"
                                        item-text="subjectname" item-value="id" label="Subject" persistent-hint
                                        single-line></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="courserule" :items="rulelist"
                                        item-text="name" item-value="id" label="Type" persistent-hint
                                        single-line></v-autocomplete>
                                </v-col>
                                <!-- <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="ay" :items="aylist" item-text="ay" item-value="id" label="Academic year" persistent-hint return-object single-line></v-autocomplete>
                                </v-col> -->
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="standard" :items="standardlist"
                                        item-text="name" item-value="id" label="Standard" persistent-hint
                                        single-line></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded outlined dense v-model="sort_order"
                                        label="Sort Order"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded type="number" outlined dense v-model="credit"
                                        label="Credit"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="subject_type"
                                        :items="subjecttypelist" item-text="name" item-value="id" label="Subject Type"
                                        persistent-hint single-line></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="pp_course_type"
                                        :items="primary_report_card_course_type" item-text="name" item-value="id"
                                        label="Primary Report Card Subject Type" persistent-hint
                                        single-line></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="combine_course"
                                        :items="combine_course_list" item-text="name" item-value="id"
                                        label="Course Combine Header" persistent-hint single-line></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="entrytype" :items="entrytypelist"
                                        item-text="name" item-value="id" label="Mark Entry Type" persistent-hint
                                        single-line @change="getscheme(ay, entrytype)"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded type="number" outlined dense v-model="passing_marks"
                                        label="Passing Marks"></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12" sm="6" md="6" class="p-0 m-0" v-if="entrytype!=null && entrytype_name != 'Grading'">
                            <v-autocomplete rounded outlined dense v-model="assesmentscheme" :items="assesmentschemelist" item-text="name" item-value="id" label="Assessment Scheme" persistent-hint  single-line></v-autocomplete>
                        </v-col> -->

                                <!-- <v-col cols="12" sm="6" md="6" class="p-0 m-0" v-if="entrytype != null">
                                    <v-autocomplete rounded outlined dense v-model="gradescheme" :items="gradeschemelist" item-text="name" item-value="id" label="Grade Scheme" persistent-hint single-line></v-autocomplete>
                                </v-col> -->
                                <v-col cols="12" sm="6" md="6">
                                    <v-checkbox class="pb-5" v-model="isactive" color="success"
                                        label="isActive?"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-row justify="center">
                            <v-btn class="button" @click="dialog = false">Cancel</v-btn>
                            <v-btn class="button" @click="save">Save</v-btn>
                        </v-row>
                    </v-col>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog1" max-width="900px">
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>Offered Subject</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row class="p-0 m-0">
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded outlined filled readonly dense v-model="editedItem.subject"
                                        label="Subject"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded outlined filled readonly dense
                                        v-model="editedItem.academicyear" label="Academic year"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded outlined filled readonly dense v-model="editedItem.standard"
                                        label="Standard"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded outlined dense v-model="editedItem.sort_order"
                                        label="Sort Order"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded type="number" outlined dense v-model="editedItem.credit"
                                        label="Credit"></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded outlined filled readonly dense v-model="editedItem.subjectrule" label="Subject Rule"></v-text-field>
                                </v-col> -->
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="editedItem.subjectrule"
                                        :items="rulelist" item-text="name" return-object label="Subject Rule"
                                        persistent-hint single-line></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="editedItem.subjecttype"
                                        :items="subjecttypelist" item-text="name" return-object label="Subject Type"
                                        persistent-hint single-line></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="editedItem.pp_course_type"
                                        :items="primary_report_card_course_type" item-text="name" return-object
                                        label="Primary Report Card Subject Type" persistent-hint
                                        single-line></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field filled readonly rounded outlined dense v-model="editedItem.entrytype"
                                        label="Mark Entry Type"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-autocomplete rounded outlined dense v-model="editedItem.combine_course_edit"
                                        :items="combine_course_list" item-text="name" item-value="id"
                                        label="Course Combine Header" persistent-hint single-line></v-autocomplete>
                                </v-col>
                                 <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                                    <v-text-field rounded type="number" outlined dense v-model="editedItem.passing_marks"
                                        label="Passing Marks"></v-text-field>
                                </v-col>
                                <!--   <v-col cols="12" sm="6" md="6" class="p-0 m-0">
                            <v-text-field filled readonly rounded outlined dense v-model="editedItem.subjecttype" label="Subject Type"></v-text-field>
                        </v-col> -->
                                <!-- <v-col cols="12" sm="6" md="6" class="p-0 m-0" v-if="editedItem.gradescheme">
                                    <v-text-field filled readonly rounded outlined dense v-model="editedItem.gradescheme" label="Grade Scheme"></v-text-field>
                                </v-col> -->

                                <v-col cols="12" sm="6" md="6">
                                    <v-checkbox class="pb-5" v-model="isactive" color="success"
                                        label="isActive?"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-row justify="center">
                            <v-btn class="button" @click="dialog1 = false">Cancel</v-btn>
                            <v-btn class="button" @click="save_edit">Save</v-btn>
                        </v-row>
                    </v-col>
                </v-card>
            </v-dialog>

            <template v-if="load == true && list_selected_ay">
                <!-- <download-excel
                    class="mr-2 pb-3 pt-2"
                    :data="bookList1"
                    :fields="table_fields"
                    worksheet="OfferSubjectData"
                    name="OfferSubjectData.xls"
                    >
                    <v-btn color="success" outlined rounded>
                        <v-icon dark>mdi-file-excel</v-icon> Export
                    </v-btn>
                </download-excel> -->
                <!-- <v-btn class="exportbtn" color="success" outlined rounded>
                    <download-excel class="mr-2 pb-3 pt-2" :data="bookList1" :fields="table_fields" worksheet="OfferSubjectData" name="OfferSubjectData.xls"> <v-icon dark>mdi-file-excel</v-icon> Export </download-excel>
                </v-btn> -->
                <v-btn class="ma-2 no-display " rounded color="success" outlined
                    @click="fnExcelReport('my-table-id', 'OfferSubject')" :loading="loader"><v-icon
                        color="success">mdi-export</v-icon>Export</v-btn>
                <div id="my-table-id">
                    <v-data-table :headers="headers" :items="bookList1" dense sort-by="" class="elevation-1 mytable"
                        :search="search" @current-items="getFiltered" :items-per-page="-1">
                        <template v-slot:item.action="{ item }">
                            <div>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                        <template v-slot:item.isactive="{ item }">
                            <span v-if="item.isactive">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:top class="pb-5">
                            <v-row justify="center" align="center">
                                <tr class="t-row">
                                    <div>
                                        <th>
                                            <v-row>
                                                <span v-for="header in headers" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                            rounded dense outlined color="#0F2027" :label="header.text"
                                                            multiple clearable :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </th>
                                    </div>
                                </tr>
                            </v-row>
                        </template>
                    </v-data-table>
                </div>
            </template>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed


export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            errorMsg: {},
            loader:false,
            search: "",
            snackbar_msg: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            load: false,
            dialog: false,
            subject_type: "",
            pp_course_type: "",
            sort_order: null,
            filterArr: [],
            filters: {
                academicyear: [],
                standard: [],
                subjectcode: [],
                subject: [],
            },
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Subject Code", value: "subjectcode" },
                { text: "Subject", value: "subject" },
                { text: "Subject Rule", value: "subjectrule" },
                { text: "Sort Order", value: "sort_order" },
                { text: "Credit", value: "credit" },
                { text: "Passing Marks", value: "passing_marks" },
                { text: "Academic Year", value: "academicyear" },
                { text: "Standard", value: "standard" },
                { text: "Subject Type", value: "subjecttype" },
                { text: "Primary Report Card Subject Type", value: "pp_course_type" },
                { text: "Combine Course Header", value: "combine_course" },
                { text: "Grading Scheme", value: "gradescheme" },
                { text: "Mark Entry Type", value: "entrytype" },
                { text: "Status", value: "isactive" },
                { text: "Actions", value: "action", sortable: false },
            ],
            table_fields: {
                "Sr. No": "srno",
                "Subject Code": "subjectcode",
                Subject: "subject",
                "Subject Rule": "subjectrule",
                "Academic Year": "academicyear",
                Standard: "standard",
                "Subject Type": "subjecttype",
                "Combine Course Header": "combine_course",
                "Grading Scheme": "gradescheme",
                "Mark Entry Type": "entrytype",
            },
            subjectlist: "",
            subject: null,
            combine_course: null,
            combine_course_list: [],
            rulelist: "",
            courserule: null,
            aylist: "",
            ay: null,
            standardlist: "",
            standard: null,
            gradeschemelist: "",
            gradescheme: null,
            assesmentschemelist: "",
            assesmentscheme: null,
            entrytypelist: "",
            entrytype: null,
            isactive: true,
            editedItem: "",
            dialog1: false,
            entrytype_name: null,
            subjecttypelist: null,
            credit: null,
            primary_report_card_course_type: null,
            list_ay:[],
            list_selected_ay:null,
            courseofferinglist:[],
            passing_marks:null,
        }),
        computed: {
            bookList1() {
                return this.courseofferinglist.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        mounted() {
            this.getsubjectoffering();
        },

        methods: {
            fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Subject Code</th>
      <th>Subject</th>
      <th>Subject Rule</th>
      <th>Sort Order</th>
      <th>Credit</th>
      <th>Passing Marks</th>
      <th>Academic Year</th>
      <th>Standard</th>
      <th>Subject Type</th>
      <th>Primary Report Card Subject Type</th>
      <th>Combine Course Header</th>
      <th>Grading Scheme</th>
      <th>Marks Entry Type</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>`;

  this.bookList1.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${item.subjectcode || ''}</td>
        <td>${item.subject || ''}</td>
        <td>${item.subjectrule || ''}</td>
        <td>${item.sort_order !== null ? item.sort_order : ''}</td>
        <td>${item.credit !== null ? item.credit : ''}</td>
        <td>${item.passing_marks !== null ? item.passing_marks : ''}</td>
        <td>${item.academicyear || ''}</td>
        <td>${item.standard || ''}</td>
        <td>${item.subjecttype || ''}</td>
        <td>${item.pp_course_type || ''}</td>
        <td>${item.combine_course || ''}</td>
        <td>${item.gradescheme || ''}</td>
        <td>${item.entrytype || ''}</td>
        <td>${item.isactive ? 'Active' : 'Inactive'}</td>
        <td>Action</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
            getOffSub(){
                // alert("getOffSub--")
               console.log(this.list_selected_ay)
               this.courseofferinglist = []
               this.courseofferinglist = this.list_selected_ay.courseofferinglist
              //  console.log(this.courseofferinglist)
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.courseofferinglist.map((d) => d[val]);
            },
            getscheme(ay, entrype) {
                // alert(ay)
                // alert(entrype)
                const data = {
                    ay: ay.id,
                    entrytype: entrype,
                };
                axios
                    .post("/Examination/getScheme", data)
                    .then((res) => {
                        this.gradeschemelist = res.data.gradingscheme_list;
                        //  this.assesmentschemelist = res.data.assessmentsscheme_list;
                        this.entrytype_name = res.data.entry_type;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                    });
            },
            offer() {
                this.dialog = true;
            },
            editItem(item) {
                this.editedItem = Object.assign({}, item);
                this.dialog1 = true;
            },
            save_edit() {
                var gs;
                var cs;
               
                if (this.editedItem.combine_course_edit != null) {
                    cs = this.editedItem.combine_course_edit;
                }
                var ppcr_type;
                var subject_type
                if (this.editedItem.pp_course_type != null) {
                    ppcr_type = this.editedItem.pp_course_type.id;
                }
                if (this.editedItem.subjecttype != null) {
                    subject_type = this.editedItem.subjecttype.id;
                }
                //  alert(ppcr_type)
                const data = {
                    ay: this.editedItem.academicyear.id,
                    subject: this.editedItem.subject.id,
                    courserule: this.editedItem.subjectrule.id,
                    standard: this.editedItem.standard.id,
                   // gradescheme: gs,
                    subject_type: subject_type,
                    pp_course_type: ppcr_type,
                    entrytype: this.editedItem.entrytype.id,
                    isactive: this.isactive,
                    coff_id: this.editedItem.coff_id,
                    combine_course: cs,
                    sort_order: this.editedItem.sort_order,
                    credit: this.editedItem.credit,
                    passing_marks: this.editedItem.passing_marks
                    // subjecttype:this.editedItem.subjecttype.id
                };
                axios
                    .post("/Examination/editCourseoffering", data)
                    .then((res) => {
                        this.showSnackbar("#4caf50", " Subject Updated Successfully..."); // show snackbar on success
                        this.dialog1 = false;
                        // this.getsubjectoffering();
                        // this.getOffSub();
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.getsubjectoffering();
                        this.getOffSub();
                      
                       
                    });
            },
            save() {
                // if(this.ay && this.subject && this.standard  && this.entrytype && this.subject_type){}
                if ( this.subject && this.standard && this.entrytype && this.sort_order && this.credit) {
                } else {
                    this.showSnackbar("#b71c1c", "Please Select All Data!!!"); // show snackbar on success
                    return;
                }
                var ppcr_type;
                if (this.pp_course_type != null) {
                    ppcr_type = this.pp_course_type;
                }
                const data = {
                  //  ay: this.ay.id,
                    ay: this.list_selected_ay.id,
                    subject: this.subject,
                    courserule: this.courserule,
                    standard: this.standard,
                   // gradescheme: this.gradescheme,
                    subject_type: this.subject_type,
                    pp_course_type: ppcr_type,
                    entrytype: this.entrytype,
                    isactive: this.isactive,
                    combine_course: this.combine_course,
                    sort_order: this.sort_order,
                    credit: this.credit,
                    passing_marks: this.passing_marks
                };
                axios
                    .post("/Examination/saveCourseoffering", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.showSnackbar("#4caf50", "New Subject added Successfully..."); // show snackbar on success
                            this.dialog = false;
                            this.getsubjectoffering();
                        } else if (res.data.msg == "300") {
                            this.showSnackbar("#4caf50", res.data.description); // show snackbar on success
                            this.dialog = false;
                            this.getsubjectoffering();
                        }
                        this.getsubjectoffering();
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                        this.dialog = false;
                    })
                    .finally(() => {
                        // //close loader
                        (this.subject = null), (this.courserule = null), (this.standard = null), (this.gradescheme = null), (this.subject_type = null), (this.pp_course_type = null);
                        (this.entrytype = null), (this.ay = null), this.getsubjectoffering();
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getsubjectoffering() {
                axios
                    .post("/Examination/subjectoffering")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.standardlist = res.data.standardlist;
                            this.subjectlist = res.data.subjectlist;
                            this.aylist = res.data.aylist;
                            this.rulelist = res.data.rulelist;
                            this.list_ay = res.data.list_ay;
                          //  this.courseofferinglist = res.data.courseofferinglist;
                            this.entrytypelist = res.data.entrytype_list;
                            this.gradeschemelist = res.data.gradingscheme_list;
                            this.subjecttypelist = res.data.subjecttypelist;
                            this.primary_report_card_course_type = res.data.primary_report_card_course_type;
                            this.combine_course_list = res.data.combine_course_list;
                            // this.assesmentschemelist = res.data.assessmentsscheme_list;
                            this.load = true;
                            this.ay = res.data.curr_ay;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    });
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
